import { render, staticRenderFns } from "./AIdialogue.vue?vue&type=template&id=79c23cff&scoped=true"
import script from "./AIdialogue.vue?vue&type=script&lang=js"
export * from "./AIdialogue.vue?vue&type=script&lang=js"
import style0 from "./AIdialogue.vue?vue&type=style&index=0&id=79c23cff&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79c23cff",
  null
  
)

export default component.exports